import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import SlidingCarousel from '../../features/SlidingCarousel'
import SplitScreen from '../../features/SplitScreen'
import AccordionContent from '../../features/AccordionContent'

import {
  HeadingText,
  HeroQuoteWrapper,
  ParagraphText,
  ArrowLink,
  Profile,
  Separator,
  QuoteImageContainer,
  Row,
  ImageSection,
  CaptionedImage,
  StatRowsWrapper,
  Last,
} from './HowItWorks.styles'

import quotesSrc from '../../images/quotes.png'
import Arrow from './primitives/Arrow'
import CtaButton from '../../primitives/CtaButton'
import ArrowGraphic from './features/ArrowGraphic'

const HowItWorks = ({
  split1,
  separator,
  split2,
  imageSection,
  split3,
  split4,
  arrowGraphic,
  statRows,
  statRowsImages,
  last,
}) => {
  return (
    <div>
      <SplitScreen
        innerMax="1210px"
        gWidth={448}
        reverse
        pad="7.125rem 0 0 0"
        textMax={split1.maxWidth}
        textComponent={
          <>
            <HeroQuoteWrapper>
              <QuoteImageContainer>
                <img
                  src={quotesSrc}
                  alt="Quotes graphic indicating the overlayed text is a quote"
                />
              </QuoteImageContainer>
              <HeadingText>{split1.quoteText}</HeadingText>
            </HeroQuoteWrapper>

            <CtaButton square minW="240px" slug={split1.ctaLink}>
              {split1.ctaText || 'Join the Movement'}
            </CtaButton>

            <ArrowLink to={split1.arrowLink}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  color: split1.ctaColor || 'inherit',
                }}
              >
                Learn more about the program
                <Arrow fill={split1.ctaColor || ''} />
              </div>
            </ArrowLink>
          </>
        }
        {...split1}
      />

      <Separator>
        <div className="line" />
        <p>
          {separator.text1 + ' '}
          <span>{separator.bold}</span>
          {' ' + separator.text2}
        </p>
        <div className="line" />
      </Separator>

      <SplitScreen
        innerMax="1100px"
        gWidth={480}
        pad="5rem 0 12rem"
        textMax="400px"
        textComponent={
          <div>
            <HeadingText style={{ marginBottom: '2.4rem' }}>
              {split2.headerText}
            </HeadingText>
            <ParagraphText
              style={{ marginBottom: '3.4rem', fontWeight: '400' }}
            >
              {split2.subText}
            </ParagraphText>
            {split2.accordions.map((accordion, i) => (
              <AccordionContent key={`split2-accordion-${i}`} {...accordion} />
            ))}
          </div>
        }
        graphicComponent={
          <SlidingCarousel
            outerControls
            slideStyle2
            minHeight="640px"
            maxWidth="400px"
            mobileMinHeight={split2.carouselContent.mobileMinHeight}
            mobilePad={split2.carouselContent.mobilePad}
            content={split2.carouselContent.content}
            leftAlign={split2.carouselContent.leftAlign}
            defaultWait={
              !!split2.carouselContent.defaultWait
                ? split2.carouselContent.defaultWait
                : 7000
            }
            maxTurns={
              !!split2.carouselContent.maxTurns
                ? split2.carouselContent.maxTurns
                : 5
            }
          />
        }
      />

      <ImageSection>
        <CaptionedImage
          className="left"
          maxWidth={imageSection.left.fluid.width}
        >
          <GatsbyImage image={imageSection.left.fluid} alt="" />
          <p>{imageSection.left.caption}</p>
        </CaptionedImage>
        <div className="center">
          <HeadingText
            style={{
              maxWidth: imageSection.headingWidth,
              marginBottom: '3rem',
            }}
          >
            {imageSection.heading}
          </HeadingText>
          <CaptionedImage maxWidth={imageSection.center.fluid.width}>
            <GatsbyImage image={imageSection.center.fluid} alt="" />
            <p>{imageSection.center.caption}</p>
          </CaptionedImage>
        </div>
        <CaptionedImage
          className="right"
          maxWidth={imageSection.right.fluid.width}
        >
          <GatsbyImage image={imageSection.right.fluid} alt="" />
          <p>{imageSection.right.caption}</p>
        </CaptionedImage>
      </ImageSection>

      <StatRowsWrapper>
        {statRows.map((row, i) => (
          <Row key={`row-${i}`}>
            <div className="stat">{row.stat}</div>
            <div className="para">
              <HeadingText style={{ fontWeight: '500' }}>
                {row.para.head}
              </HeadingText>
              <p>{row.para.text}</p>
            </div>
          </Row>
        ))}
        {statRowsImages.map((img, i) => (
          <CaptionedImage
            className={`floating-img${i === 0 ? ' left' : ' right'}`}
            key={`stat-row-image-${i}`}
            maxWidth={273}
          >
            <GatsbyImage image={img.fluid} alt="" />
            <p>{img.caption}</p>
          </CaptionedImage>
        ))}
      </StatRowsWrapper>
      {!!split3 ? (
        <SplitScreen
          innerMiddle="8rem"
          innerMax="1100px"
          gWidth={374}
          textMax="574px"
          textComponent={
            <div>
              {split3.accordions.map((accordion, i) => (
                <AccordionContent
                  key={`split3-accordion-${i}`}
                  {...accordion}
                />
              ))}
            </div>
          }
          graphicComponent={
            <CaptionedImage>
              <GatsbyImage image={split3.graphic.fluid} alt="" />
              <p>{split3.graphic.caption}</p>
            </CaptionedImage>
          }
        />
      ) : (
        <div style={{ padding: '1.4rem' }} />
      )}

      <ArrowGraphic {...arrowGraphic} />

      <div
        style={{
          maxWidth: '1166px',
          margin: '0 auto 2.2rem',
          padding: '0 1.8rem',
        }}
      >
        <HeadingText
          style={{
            maxWidth: split4.headMax || '600px',
          }}
        >
          {split4.headerText}
        </HeadingText>
      </div>
      <SplitScreen
        reverse
        first
        noGraphicMobile
        innerMax={split4.innerMax || '1150px'}
        gWidth={split4.graphic.width || 400}
        pad="0 0 9rem"
        textMax={split4.textMax || '620px'}
        // innerMiddle={!!split4.innerMiddle && split4.innerMiddle}
        textComponent={
          <div>
            <p
              style={{
                fontSize: '20px',
                fontWeight: '500',
                color: '#808080',
                marginBottom: '1rem',
              }}
            >
              {split4.subHead}
            </p>
            <p
              style={{
                marginBottom: '2.6rem',
                fontSize: '2rem',
                position: 'relative',
                fontWeight: '300',
              }}
            >
              {!split4.noQuotes && (
                <span
                  style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    transform: 'translateX(-100%)',
                  }}
                >
                  “
                </span>
              )}
              {split4.quoteText}
              {!split4.noQuotes && (
                <span style={{ position: 'absolute' }}>”</span>
              )}
            </p>
            {split4.profile && (
              <Profile>
                <GatsbyImage image={split4.profile.img} alt="" />
                <p>{split4.profile.name}</p>
              </Profile>
            )}
            {split4.accordions.map((accordion, i) => (
              <AccordionContent key={`split4-accordion-${i}`} {...accordion} />
            ))}
          </div>
        }
        {...split4}
      />

      <div style={{ maxWidth: '1166px', margin: '0 auto 2.6rem' }}>
        <HeadingText
          style={{
            maxWidth: last.maxWidth || '600px',

            margin: '0 1.8rem',
          }}
        >
          {last.headerText}
        </HeadingText>
      </div>

      <Last
        style={{
          maxWidth: `${last.fluid.width}`,
        }}
      >
        <GatsbyImage image={last.fluid} objectFit={"contain"} alt="" />
      </Last>
    </div>
  )
}

export default HowItWorks
